<div [dfs]="'bg:w p-a:2 t:shadow-1 br:2px'"
     (offClick)="finishSelection()"
     [offClickState]="openState">

    <div [dfs]="'d:flex m-t:2 flex-justify-content:center'"
         [style.gap.px]="2"
         [style.font-size.px]="32">
        <p [dfs]="[hour ? 'c:1' : 'c:14', 'cursor:pointer']"
           (click)="setIsMinute(false)">{{ hour || '00' }}</p>
        <p [dfs]="'c:14'">:</p>
        <p [dfs]="[minute ? 'c:1' : 'c:14', 'cursor:pointer']"
           (click)="setIsMinute(true)">{{ minute || '00' }}</p>
    </div>

    <div [dfs]="'m-t:3 bg:16 br:50% w:100% ratio:1x1 pos:relative'"
         [ngSwitch]="isMinute">

        <div *ngSwitchCase="false"
             class="_shield"
             [style.--current]="currentIndex(amHours, hour)"
             [class._current]="isCurrentShield(amHours, hour)">
            <i *ngFor="let h of amHours"
               [dfs]="'t:p2 c:1'"
               [class._current]="isSelected(h, hour)"
               (click)="pickHour(h)">{{h}}</i>
            <span class="_pointer"></span>
        </div>
        <div *ngSwitchCase="false"
             class="_shield _smallShield"
             [style.--current]="currentIndex(pmHours, hour)"
             [class._current]="isCurrentShield(pmHours, hour)">
            <i *ngFor="let h of pmHours"
               [dfs]="'t:c1 c:14'"
               [class._current]="isSelected(h, hour)"
               (click)="pickHour(h)">{{h}}</i>
            <span class="_pointer"></span>
        </div>
        <div *ngSwitchCase="true"
             class="_shield"
             [style.--current]="currentIndex(minutes, minute)"
             [class._current]="isCurrentShield(minutes, minute)">
            <i *ngFor="let m of minutes"
               [dfs]="'t:p2 c:1'"
               [class._current]="isSelected(m, minute)"
               (click)="pickMinutes(m)">{{m}}</i>
            <span class="_pointer"></span>
        </div>

    </div>
</div>
